import { Util } from "@/types/util-type";
import { useRouter } from "vue-router";
import { ElNotification } from "element-plus";

export default function useUtils(): Util {
  const router = useRouter();
  // handler for change of path
  const route_handler = (path: string): void => {
    router.push({ path });
  };
  const show_notification = (
    message: string,
    time?: number,
    title?: string
  ): void => {
    ElNotification({
      title: title ?? "Error",
      message,
      type: title ? "success" : "error",
      duration: time ?? 3000,
    });
  };
  return { route_handler, show_notification };
}
